import { Component } from '@angular/core';

import { OnInit } from '@angular/core';

import * as moment from 'moment';
import { FieldGeneratorService } from '../../services/field-generator.service';
import { FormDialogComponent } from '../form-dialog/form-dialog.component';
import { MatDialog } from '@angular/material';
import { MedicineDetailComponent } from '../medicine-detail/medicine-detail.component';
import { MedicineService } from '../../services/medicine.services';
import { IncidentsDialogComponent } from '../incidents-dialog/incidents-dialog.component';
import { EventBusService } from '../../services/event-bus.service';
import { GlobalCfgService } from '../../services/globalcfg.service';
import { ActivatedRoute } from '@angular/router';
import { AddProductDialogComponent } from '../add-product/add-product.component';

@Component({
  selector: 'rm-manage-medicine',
  templateUrl: './manage-medicine.component.html',
  styleUrls: ['./manage-medicine.component.css'],
})
export class ManageMedicineComponent implements OnInit {
  data: any[] = [];
  columns: any[];
  gcp: any;
  subscriptions: any[] = [];
  locations: any;
  searchTxt = '';
  private appliedSearchTerm = ''; // Used to track the last applied search term

  //Used for pagination
  bookmark: string = '';
  totalCount: number = 0;
  pageSize: number = 5;
  skip: number = 0;
  selectedLocation: string = 'all';
  bookmarks: any[] = [];
  labels: any;
  role: any;

  // Sorting state
  sortBy: string = 'name'; // Default sort column
  sortOrder: 'asc' | 'desc' = 'asc'; // Default sort order

  constructor(
    private dialog: MatDialog,
    private fgService: FieldGeneratorService,
    private ebService: EventBusService,
    private medicineService: MedicineService,
    private globalCfgService: GlobalCfgService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.gcp = this.globalCfgService.getGcp();
    this.labels = this.globalCfgService.getSettingValue('labels');
    this.columns = [
      {
        name: 'image',
        dataKey: 'attributes.imgPath',
        displayName: '',
        type: 'image',
      },
      {
        name: 'name',
        dataKey: 'attributes.name',
        displayName: this.labels['medicine'],
        actionable: true,
        sortable: true,
      },
      {
        name: 'type',
        dataKey: 'attributes.type',
        displayName: 'Type',
        sortable: true,
      },
      {
        name: 'composition',
        dataKey: 'attributes.composition',
        displayName: this.labels['composition'],
        sortable: true,
      },
      {
        name: 'location',
        dataKey: 'location',
        displayName: this.labels['mfg_location'],
        sortable: true,
      },
      { name: 'actions', displayName: '', type: 'actions' },
    ];
    this.subscriptions.push(
      this.ebService.locationsListValue$.subscribe((locations) => {
        this.locations = locations;
      })
    );
    this.subscriptions.push(this.ebService.particpantSelectionFetchedValue$.subscribe(
      (gcp) => {
        this.gcp = gcp;
        this.load();
      }
    ));

    this.route.parent.url.subscribe(url => {
      //always the first part is role
      this.role = url.values().next().value.path;
    });

    this.load();
  }

  load() {
    this.ebService.loadLocationsList(this.gcp);
    this.loadMedicineData();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  loadMedicineData(page?) {
    if (!this.gcp) {
      this.gcp = this.globalCfgService.getGcp();
    }
    var obj = {
      gcp: this.gcp,
      pageSize: this.pageSize,
      skip: this.skip,
      gln: this.selectedLocation === 'all' ? undefined : this.selectedLocation,
      search: this.appliedSearchTerm || '',
    };

    if (page) {
      this.skip = page.pageIndex * this.pageSize;
      obj.skip = this.skip;
    }

    this.medicineService
      .get(obj, this.sortBy, this.sortOrder)
      .subscribe((response) => {
        var data = response['result'];
        data.forEach(element => {
          element.actions = [
            { name: 'map', tip: 'View Distribution' }
          ];

          if (this.role == 'admin') {
            element.actions.unshift({ name: 'edit', tip: 'Edit ' + this.labels.medicine });
          }
        });

        this.data = Object(data);
        this.totalCount = response['metadata'].totalCount;
      });
  }

  onSort(columnName: string) {
    console.log(
      'ManageMedicineComponent: onSort event received. Sorting by:',
      columnName
    );
    // The backend expects the sort key without 'attributes.'
    const sortBy = columnName.replace('attributes.', '');

    if (this.sortBy === sortBy) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortBy = sortBy;
      this.sortOrder = 'asc';
    }
    this.skip = 0;
    this.bookmarks = [];
    this.loadMedicineData();
  }

  getSortIndicator(columnName: string): string {
    if (this.sortBy === columnName) {
      return this.sortOrder === 'asc' ? 'arrow_upward' : 'arrow_downward';
    }
    return '';
  }

  add() {
    const dialogRef = this.dialog.open(AddProductDialogComponent, {
      width: '1200px',
      data: {
        title: 'Create ' + this.labels.medicine,
        fields: this.fgService.getFields(this.columns, {}),
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {
        this.loadMedicineData();
      }
    });
  }

  onActionClicked(e) {
    console.log('onActionClicked:', e);

    var rec = e.record;
    switch (e.actionName.name) {
      case 'map':
        this.dialog.open(IncidentsDialogComponent, {
          width: '2400px',
          data: {
            title: 'Distribution',
            productId: rec.id,
            gcp: this.globalCfgService.getGcp(),
          },
        });
        break;
      case 'edit':
        var dialogRef = this.dialog.open(AddProductDialogComponent, {
          width: '2400px',
          data: {
            title: 'Edit ' + this.labels.medicine,
            mode: 'edit',
            data: {
              id: rec.id,
              img: rec.attributes.imgPath,
              gtin: rec.id,
              gln: rec.gln,
              type: rec.attributes.type,
              name: rec.attributes.name,
              aNORCameroonStandardNumber: rec.attributes
                .aNORCameroonStandardNumber
                ? rec.attributes.aNORCameroonStandardNumber
                : '', // camtrade pass attribute
              composition: rec.attributes.composition,
              units: rec.attributes.units,
              minTemperature: rec.attributes.minTemperature,
              maxTemperature: rec.attributes.maxTemperature,
              minHumidity: rec.attributes.minHumidity,
              maxHumidity: rec.attributes.maxHumidity,
              tempThreshold: rec.attributes.tempThreshold,
              humidityThreshold: rec.attributes.humidityThreshold,
              expiryDateType: rec.attributes.expiryDateType || 'expiry',
            },
          },
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result == 'yes') {
            this.loadMedicineData();
          }
        });
        break;
      default:
        console.log('Unhandled actionable: ', e.actionName);
    }
  }

  onActionableClicked(e) {
    console.log('onActionableClicked:', e);

    var rec = e.record;
    switch (e.actionName) {
      case 'name':
      case 'attributes.name':
        this.dialog.open(MedicineDetailComponent, {
          width: '2400px',
          data: { medicineId: rec.id },
        });
        break;
      default:
        console.log('Unhandled actionable: ', e.actionName);
    }
  }

  applyFilter() {
    const term = (this.searchTxt || '').trim();
    if (!term) return;
    if (this.appliedSearchTerm === term) return; // Avoid redundant API calls

    this.appliedSearchTerm = term;
    // Always reset to first page when searching
    this.skip = 0;
    this.loadMedicineData();
  }

  clear() {
    if (!this.appliedSearchTerm) {
      this.searchTxt = '';
      return;
    }
    this.searchTxt = '';
    this.appliedSearchTerm = '';
    this.skip = 0;
    this.loadMedicineData();
  }

  onPageChanged(page) {
    this.pageSize = page.pageSize;
    this.loadMedicineData(page);
  }
}
